import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDwKOO98Oempk46jO4A3hsxYVmzsok00AI",
  authDomain: "bizflex-e7f07.firebaseapp.com",
  projectId: "bizflex-e7f07",
  storageBucket: "bizflex-e7f07.firebasestorage.app",
  messagingSenderId: "1007292068858",
  appId: "1:1007292068858:web:726cbd917b4f71591bea43",
  measurementId: "G-L3JPLZNMED",
};

const app = initializeApp(firebaseConfig);

let analytics = null;

isSupported()
  .then((supported) => {
    if (supported && typeof window !== "undefined") {
      analytics = getAnalytics(app);
    }
  })
  .catch((error) => {
    // Silently handle error
  });

export { app, analytics };
